'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { LaunchpoolItemIdContext, launchpoolBunja } from '@flipster/features/src/shared/launchpool/state';
import { Spinner } from '@flipster/react/design-system/spinner';
import { center } from '@flipster/styled-system/patterns';

import LaunchpoolItem from './_Item';
import SparkLaunchpoolItem from './_Item/spark/SparkLaunchpoolItem';

const LaunchpoolList = () => {
  const { launchpoolApiIsLoadingAtom, launchpoolIdAndIsSparksAtom } = useBunja(launchpoolBunja);
  const launchpoolApiIsLoading = useAtomValue(launchpoolApiIsLoadingAtom);
  const launchpoolIdAndIsSparks = useAtomValue(launchpoolIdAndIsSparksAtom);

  if (launchpoolApiIsLoading) {
    return (
      <div className={center({ w: '100%', h: 300 })}>
        <Spinner />
      </div>
    );
  }

  return (
    <>
      {launchpoolIdAndIsSparks.map(({ id, isSparkLaunchpool }) => (
        <LaunchpoolItemIdContext value={id} key={id}>
          {isSparkLaunchpool ? <SparkLaunchpoolItem /> : <LaunchpoolItem />}
        </LaunchpoolItemIdContext>
      ))}
    </>
  );
};

export default LaunchpoolList;
